module.exports = __webpack_public_path__ + "img/line-event.98def769.svg";